<template>
	<div class="action-items">
		<div v-for="(action, index) in actions" :key="index">
			<!-- Consider just binding props -->
			<BaseActionItem
				:name="action.name"
				:value="action.value"
				:accessory="action.accessory"
				:flip="action.flip"
				:clickHandler="action.clickHandler"
				:hideBorder="lastActionItem(index)"
				:disabled="action.disabled || false"
				:error="action.error || false" />
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			actions: {
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		methods: {
			lastActionItem(index) {
				const actions = this.actions;
				const lastIndex = actions.length - 1;
				return (index === lastIndex);
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import 'commonStyle/form';
	.margin-bottom {
		margin-bottom: 0.5em;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseActions.vue